import { id } from 'date-fns/locale';

export class ProfilDetails {
  static Prerequities: any[] = [
    { name: 'JAVA', level: 'Tres Bon niveau' },
    { name: 'POO', level: 'Niveau Intermediaire' },
  ];

  //Pour les candidatures
  static Availability: any[] = [
    { id: 0, value: 'Très limitée (moins de 1h par jour)' },
    { id: 1, value: 'Limitée (entre 1 et 2h par jour)' },
    { id: 2, value: 'Moyennement disponible (entre 2 et 3h par jour)' },
    { id: 3, value: 'Disponible (entre 3 et 4h par jour)' },
    { id: 4, value: ' Très disponible (plus de 4h par jour)' },
  ];

  //Pour les candidatures

  static Discipline: any[] = [
    {
      id: 0,
      name: 'Gestion (commerce, marketing, ressources humaines, etc.) / Économie / Administration ',
    },
    { id: 1, name: 'Sciences de l’information et de la communication ' },
    { id: 2, name: 'Informatique / Télécommunications ' },
    { id: 3, name: 'Santé (médecine, pharmacie, etc.) / Social ' },
    { id: 4, name: 'Mathématiques / Statistiques ' },
    {
      id: 5,
      name: 'Environnement / Géologie / Sciences de la vie (biologie, etc.) ',
    },
    { id: 6, name: 'Sciences du génie ' },
    { id: 7, name: 'Physique / Chimie ' },
    { id: 8, name: 'Architecture Arts / Design / Culture ' },
    { id: 9, name: 'Droit / Science politique ' },
    { id: 10, name: 'Éducation ' },
    { id: 11, name: 'Philosophie / Sociologie / Anthropologie / Psychologie ' },
    { id: 12, name: 'Histoire / Géographie ' },
    { id: 13, name: 'Langues / Littérature / Lettres ' },
    { id: 14, name: 'Autres' },
  ];

  //Pour les candidatures

  static Series: any[] = [
    { id: 0, name: 'S' },
    { id: 1, name: 'F' },
    { id: 2, name: 'G-STEG' },
    { id: 3, name: 'T' },
    { id: 4, name: 'L' },
    { id: 5, name: 'Autre' },
  ];

  //Pour les candidatures
  static Bareme: any[] = [
    { id: 0, name: 'Aucun', value: 1 },
    { id: 1, name: 'Faible', value: 2 },
    { id: 2, name: 'Moyen', value: 3 },
    { id: 3, name: 'Bon', value: 4 },
    { id: 4, name: 'Excellent', value: 5 },
  ];
  //Pour les candidatures
  static OtherStatus: any[] = [
    { id: 0, name: 'Salarié' },
    { id: 1, name: 'Auto-emploi' },
    { id: 2, name: 'Non-diplômé' },
    { id: 3, name: 'Autres' },
  ];

  //Pour les candidatures
  static Student: any[] = [
    { id: 0, name: 'Licence1 ou équivalent' },
    { id: 1, name: 'Licence2 ou équivalent' },
    { id: 2, name: 'Licence3 ou équivalent' },
    { id: 3, name: 'Master1 ou équivalent' },
    { id: 4, name: 'Master2 ou équivalent' },
    { id: 5, name: 'Doctorant' },
    { id: 6, name: 'Autres' },
  ];

  //Pour les candidatures
  static DiplomeForApplications: any[] = [
    { id: 0, name: 'CFEE' },
    { id: 1, name: 'BFEM' },
    { id: 2, name: 'CAP/BEP' },
    { id: 3, name: 'Baccalauréat' },
    { id: 4, name: 'BTS/DUT/DEUG' },
    { id: 5, name: 'Licence (Bac+3)' },
    { id: 6, name: 'Master 1' },
    { id: 7, name: 'Master 2' },
    { id: 8, name: 'Doctorat' },
  ];
  static Diplomes: any[] = [
    { id: 0, name: 'Aucun' },
    { id: 1, name: 'CFEE' },
    { id: 2, name: 'BFEM' },
    { id: 3, name: 'CAP/BEP' },
    { id: 4, name: 'Baccalauréat' },
    { id: 5, name: 'BTS/DUT/DEUG' },
    { id: 6, name: 'Licence' },
    { id: 7, name: 'Maîtrise' },
    { id: 8, name: 'Master' },
    { id: 9, name: 'Doctorat' },
  ];
  static Specialisations: any[] = [
    { id: 0, name: 'Agriculture et agroalimentaire' },
    { id: 1, name: 'Administration et gestion des entreprises' },
    { id: 2, name: 'Bâtiment et travaux publics' },
    { id: 3, name: 'Commerce et artisanat' },
    { id: 4, name: 'Eau et Énergie' },
    { id: 5, name: 'Finance, Banque et Assurance' },
    { id: 6, name: 'Informatique et télécom' },
    { id: 7, name: 'Mines et Industrie' },
    { id: 8, name: 'Secteur public' },
    { id: 9, name: 'Technologies du digital' },
    { id: 10, name: 'Tourisme' },
    { id: 11, name: 'Transport et logistique' },
    { id: 12, name: 'Sciences humaines et sociales' },
  ];
  static Experiences: any[] = [
    { id: 0, name: '1 an' },
    { id: 1, name: '2 ans' },
    { id: 2, name: '3 ans' },
    { id: 3, name: '4 ans' },
    { id: 4, name: '5 ans' },
    { id: 5, name: 'plus de 5 ans' },
    { id: 6, name: 'plus de 8 ans' },
  ];
  static Experiences2: any[] = [
    { id: 0, name: "Pas d'experience" },
    { id: 1, name: '0 - 6 mois' },
    { id: 2, name: '6 - 1 an' },
    { id: 3, name: '1 an' },
    { id: 4, name: '2 ans' },
    { id: 5, name: '3 ans' },
    { id: 6, name: '4 ans' },
    { id: 7, name: '5 ans' },
    { id: 8, name: 'plus de 5 ans' },
    { id: 9, name: 'plus de 8 ans' },
  ];
  static statutProfessionnels: any[] = [
    { id: 0, name: 'Étudiant' },
    { id: 1, name: 'Stage ou période d’essai' },
    { id: 2, name: 'Employé (CDD, CDI)' },
    { id: 3, name: 'Entrepreneur ou freelance' },
    { id: 4, name: 'Chercheur d’emploi' },
  ];

  //Pour stemd

  static Série4Stemd: any[] = [
    { id: 0, name: 'Enseignement Moyen' },
    { id: 1, name: 'Série S1' },
    { id: 2, name: 'Série S3' },
    { id: 3, name: 'Autres Séries Scientifiques' },
    { id: 4, name: 'Série Technique' },
    { id: 5, name: 'Série Littéraire' },
    { id: 6, name: 'Sérié Tertiaire' },
    { id: 7, name: 'Autre' },
  ];

  static Classe4Stemd: any[] = [
    { id: 0, name: 'Sixième' },
    { id: 1, name: 'Cinquième' },
    { id: 2, name: 'Quatrième' },
    { id: 3, name: 'Troisième' },
    { id: 4, name: 'Seconde' },
    { id: 5, name: 'Première' },
    { id: 6, name: 'Terminale' },
    { id: 7, name: 'Autre' },
  ];

  static Universities: any[] = [
    {
      id: 2,
      name: 'Université numérique Cheikh Hamidou KANE',
    },
    {
      id: 3,
      name: 'Université Sine-Saloum El Hadji Ibrahima Niasse',
    },
    {
      id: 4,
      name: 'Université Assane Seck de Ziguinchor',
    },
    {
      id: 5,
      name: "Institut Supérieur d'Enseignement Professionnel Bignona",
    },
    {
      id: 6,
      name: 'Université Gaston Berger',
    },
    {
      id: 7,
      name: 'Université Cheikh Anta Diop',
    },
    {
      id: 8,
      name: 'Université Alioune Diop de Bambey',
    },
    {
      id: 9,
      name: 'Université Amadou Mahtar Mbow',
    },
    {
      id: 10,
      name: 'Université Iba Der Thiam',
    },
    {
      id: 11,
      name: "Institut Supérieur d'Enseignement Professionnel Thiès",
    },
    {
      id: 12,
      name: "Institut Supérieur d'Enseignement Professionnel Richard Toll",
    },
    {
      id: 13,
      name: "Institut Supérieur d'Enseignement Professionnel Amadou Traware (ex. Isep Diamniadio)",
    },
    {
      id: 14,
      name: "Institut Supérieur d'Enseignement Professionnel Mbacké",
    },
    {
      id: 15,
      name: "Institut Supérieur d'Enseignement Professionnel Matam",
    },
    {
      id: 16,
      name: 'Lycée Amath Dansokho',
    },
    {
      id: 17,
      name: 'Lycée de Hann',
    },
    {
      id: 18,
      name: 'Lycée Aminata Sow Fall',
    },
    {
      id: 19,
      name: 'Lycée Talibou Dabou',
    },
    {
      id: 20,
      name: 'CEM ABBE ARSENE FRIDOIL',
    },
    {
      id: 21,
      name: 'CEM EL HADJ MALICK SY',
    },
    {
      id: 22,
      name: 'CEM ELHADJI OUSMANE DIOP COUMBA PATHE',
    },
    {
      id: 23,
      name: 'CEM ADAMA NDIAYE',
    },
    {
      id: 24,
      name: 'CEM Mbacké 3',
    },
    {
      id: 25,
      name: 'CEM Gaidndé Fatma Mbacké',
    },
    {
      id: 26,
      name: 'Institut Al Azhar',
    },
    {
      id: 27,
      name: 'Ecole Privée Fallou Gallas de Mbacké',
    },
    {
      id: 28,
      name: 'Ecole Privée Sokhna Mai Mbacké',
    },
    {
      id: 29,
      name: 'CEM ALIOUNE DIOP',
    },
    {
      id: 30,
      name: 'CEM AMADOU TRAWARE',
    },
    {
      id: 31,
      name: 'Lycée Limamoulaye',
    },
    {
      id: 32,
      name: 'CEM E.H Mamadou NDIAYE',
    },
    {
      id: 33,
      name: 'CEM ABBE PIERRE SOCK',
    },
    {
      id: 34,
      name: 'CEM ABDOULAYE MATHURIN DIOP',
    },
    {
      id: 35,
      name: 'Lycée de Diarrére',
    },
    {
      id: 36,
      name: 'Lycée de Soum',
    },
    {
      id: 37,
      name: 'Lycée de Foundioune',
    },
    {
      id: 38,
      name: 'Lycée de Patar sine',
    },
    {
      id: 39,
      name: 'Lycée de Sokone',
    },
    {
      id: 40,
      name: 'Lycée de Pout',
    },
    {
      id: 41,
      name: 'CEM Route de Dakar',
    },
    {
      id: 42,
      name: 'CEM Mamadou DIAW',
    },
    {
      id: 43,
      name: 'CEM Lamlam',
    },
    {
      id: 44,
      name: 'Lycée Fahu',
    },
    {
      id: 45,
      name: 'CEM OUAKAM 2',
    },
    {
      id: 46,
      name: 'Cem Blaise Diagne',
    },
    {
      id: 47,
      name: 'CEM Elh Badara Mbaye KABA',
    },
    {
      id: 48,
      name: 'Lycée FA Mouhamadou Fadilou Mbacke',
    },
    {
      id: 49,
      name: 'CEM Cheikh Awa Balla Mbacké',
    },
    {
      id: 50,
      name: 'Cem Maristes',
    },
    {
      id: 51,
      name: 'LYCÉE MIXTE NGANE SAER',
    },
    { id: 52, name: 'CEM Dahra Commune' },
    {
      id: 53,
      name: 'Lycée Mixte de Kahone',
    },
    {
      id: 54,
      name: 'Lycée Hamidou KANE',
    },
    {
      id: 55,
      name: 'Lycée Samba DIONE',
    },
    {
      id: 56,
      name: 'Lycée de Fass',
    },
    {
      id: 57,
      name: 'Lycée Sindian',
    },
    {
      id: 58,
      name: 'Lycée Aline Sitoe Diatta',
    },
    {
      id: 59,
      name: 'LYCEE ALINE SITOE',
    },
    {
      id: 60,
      name: 'Lycée de Niaguis',
    },
    {
      id: 61,
      name: 'Lycée de Sindian Bignona',
    },
    {
      id: 62,
      name: 'Lycée de RAO',
    },
    {
      id: 63,
      name: 'Lycée Hadji Oumar TALL',
    },
    {
      id: 64,
      name: 'Complexe Amadou Sow NDIAYE',
    },
    {
      id: 65,
      name: 'Lycée Ndiawdoune',
    },
    { id: 66, name: 'Lycée Taiba ICS Mboro' },
    { id: 67, name: 'Lycée Keur Madiabel' },
    { id: 68, name: 'Lycée Aline Sitoé Diatta' },
    { id: 69, name: 'Lycée de Louga' },
    { id: 69, name: 'Lycée Ngaparou' },
    { id: 70, name: 'Lycée de Mako' },
    { id: 71, name: 'Lycée Franco Arabe ZIG' },
    { id: 71, name: 'Lycée de Karang' },
    { id: 72, name: 'Lycée de Ngascope' },
    { id: 73, name: 'CEM Matar Kalla Dramé' },
    { id: 74, name: 'Lycée de Bicole' },
    { id: 75, name: 'Lycée de Balingore' },
    { id: 76, name: 'Lycée Seydina Limamou LAYE' },
    { id: 77, name: 'Lycée Mame Yeli BADIANE' },
    { id: 78, name: 'Bloc Scientifique et Technique de Tivaouane' },
    { id: 79, name: 'CEM Niague' },
    { id: 80, name: 'Lycée Niague' },
    { id: 81, name: 'CEM DENI' },
    { id: 82, name: 'CEM Bambilor' },
    { id: 83, name: 'Lycée Bambilor' },
    { id: 84, name: 'Lycée Tivaouane Peulh' },
    { id: 85, name: 'CEM Tivaouane Peulh' },
    { id: 86, name: 'CEM Banabe' },
    { id: 87, name: 'Lycée Serigne Alassane DIA' },
    { id: 88, name: 'Lycée Diack Mbodokhane' },
    { id: 89, name: 'Lycée de Kounoune' },
    { id: 90, name: 'CEM Kabatoki' },
    { id: 91, name: 'Lycée de Mbacké' },
    { id: 92, name: 'Nouveau Lycée de Mbour' },
    { id: 93, name: 'Lycée Lamine GUEYE' },

    { id: 94, name: 'CRE Sacré-cœur' },
    { id: 95, name: 'CRE Sedhiou' },
    { id: 96, name: 'CRE Medina Yoro foulah ' },
    { id: 97, name: 'CRE Bambey ' },
    { id: 98, name: 'CRE Guediaway' },
    { id: 99, name: 'CRE Tivaouane' },
    { id: 100, name: 'CRE Koki' },
    { id: 99, name: 'BST Tivaouane' },
    { id: 100, name: 'BST Sokone' },
    { id: 101, name: 'BST Tamba' },
    { id: 102, name: 'BST Bignona' },
    { id: 103, name: 'SENMATH TECH' },
    { id: 104, name: 'ENO Diourbel' },
    { id: 105, name: 'ENO Kolda' },
    { id: 106, name: 'SENBOT' },
    { id: 107, name: 'NETSOFT' },
    { id: 108, name: 'IBM Startup' },
    { id: 109, name: 'LANS' },
    { id: 110, name: 'IPM' },
    { id: 111, name: 'YEEWOU' },
    { id: 112, name: 'CRE Kolda' },
  ];

  static MiniJpo2025: any[] = [
    { id: 0, lieu: 'Saint-Louis', date: 'Le 28 Novembre 2025' },
    { id: 1, lieu: 'Kolda', date: 'Le 28 Novembre 2025' },
    { id: 2, lieu: 'Kaolack', date: 'Le 02 Décembre 2025' },
    { id: 3, lieu: 'Mbour', date: 'Le 02 Décembre 2025' },
  ];
  static Jpo2025: any[] = [
    { id: 0, lieu: "Palace de l'obelisque", date: 'Le 17 Décembre 2025' },
    { id: 1, lieu: "Palace de l'obelisque", date: 'Le 18 Décembre 2025' },
  ];
  static Family: any[] = [
    {
      name: 'DEV LOGICIEL',
      isCollapsed: true,
      parcours: [
        { code: 'DEV_MOBILE-2510', cohorte: 'SIG2510-FODE' },
        { code: 'DEVELOPPEMENT_FULL_STACK-2601', cohorte: 'SIG2601-FODE' },
      ],
    },
    {
      name: 'TECHNO EMERGENTES',
      isCollapsed: true,
      parcours: [{ code: '', cohorte: 'SIG2509-FODE' }],
    },
    {
      name: 'IA & DONNÉES',
      isCollapsed: true,
      parcours: [
        { code: '', cohorte: 'SIG2412-FODE' },
        { code: '', cohorte: 'SIG2502-FODE' },
        {
          code: 'TEST_INTELLIGENCE_ARTIFICIELLE_ET_DATA-2601',
          cohorte: 'SIG2511-FODE',
        },
      ],
    },
    {
      name: 'CCAA',
      isCollapsed: true,
      parcours: [{ code: '', cohorte: 'SIG2508-FODE' }],
    },
    {
      name: 'E-BUSINESS',
      isCollapsed: true,
      parcours: [],
    },
  ];
}
